import React from 'react';

import currencyFormatter from 'currency-formatter';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { GridLegacy as Grid, Stack } from '@mui/material';

interface Props {
  productName: string;
  total: number;
  destinationCountries: unknown[];
  currencyCode: string;
  travellers: unknown[];
  startDate: string;
  endDate: string;
}

function getTravellerDisplayName(traveller: unknown): string {
  if (traveller && typeof traveller === 'object') {
    const firstName = 'first_name' in traveller ? traveller.first_name : undefined;
    const surname = 'surname' in traveller ? traveller.surname : undefined;

    return `${firstName} ${surname}`;
  }

  return 'undefined undefined';
}

function OrderInsuranceSummary({
  productName,
  total,
  destinationCountries,
  currencyCode,
  travellers,
  startDate,
  endDate,
}: Props) {
  return (
    <div className="order-summary-panel">
      <div className="offer-meta">
        <div className="offer-title">Booking Protection or Travel Insurance</div>
      </div>

      <div className="summary-item-list" data-testid="summary-item-list">
        <div className="summary-item-item">
          <Grid container>
            <Grid item xs={12} sm={10}>
              <div className="item-detail-container">
                <div className="item-detail item-header">
                  <div className="item-name">{productName}</div>
                  <div className="item-reservation">
                    <Stack direction="row" className="section">
                      <LocationOnIcon />
                      {destinationCountries.join(', ')}
                    </Stack>
                    <Stack direction="row" className="section">
                      <ListAltIcon />
                      {travellers.map(getTravellerDisplayName).join(', ')}
                    </Stack>
                    <Stack direction="row" className="section">
                      <CalendarMonthIcon />
                      <span>{startDate}</span>
                      <span className="separator">-</span>
                      <span>{endDate}</span>
                    </Stack>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={2}>
              <div className="item-amounts">
                <div className="item-price">{currencyFormatter.format(total, { code: currencyCode })}</div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default OrderInsuranceSummary;
